import Clarity from '@microsoft/clarity';
import { environment } from '@root/environment';
// NB: this is in POC stage.  This would more likely become part of the ui-lib in 
// future to allow better tracking (https://www.npmjs.com/package/@microsoft/clarity)
function initClarity() {
  if (environment.clarityId) {
    Clarity.init(environment.clarityId);
  }
}

export { 
    initClarity 
};
